import React, { useMemo } from 'react'
import { Form } from 'antd'
import { FormItemProps } from 'antd/lib/form'
import { InputProps } from 'antd/lib/input'
import dp from 'dot-prop-immutable'

import { useT } from 'src/core/hooks/use-translation'

import * as CSS from './styles'

type Props = InputProps &
  Pick<FormItemProps, 'label' | 'required'> & {
    dataTestId: string
    formatter?(value: string | number): string
    formikProps: any
    iconInfo?: JSX.Element
    max?: number
    min?: number
    parser?(displayValue: string): string | number
  }

function InputNumber({
  dataTestId = 'input-number',
  disabled,
  formatter,
  formikProps,
  iconInfo,
  label,
  max = Infinity,
  min = -Infinity,
  name,
  parser,
  required = true,
  size = 'large'
}: Props) {
  const { t } = useT()
  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])

  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])

  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  let iconLabel = <span>{t(label)}</span>
  if (iconInfo) {
    iconLabel = (
      <>
        {iconLabel}
        {iconInfo}
      </>
    )
  }
  return (
    <Form.Item
      colon={false}
      help={touched && typeof error === 'string' ? t(error) : ''}
      label={iconLabel}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
      hasFeedback
    >
      <CSS.InputNumber
        data-test-id={dataTestId}
        disabled={disabled}
        formatter={
          formatter || (newValue => `${newValue}`.replace(/[^0-9]+/g, ''))
        }
        max={max}
        min={min}
        name={name}
        onBlur={formikProps.handleBlur}
        onChange={newValue =>
          formikProps.setFieldValue(
            name,
            +`${newValue}`.replace(/[^0-9]+/g, '')
          )
        }
        parser={parser}
        size={size}
        value={value}
      />
    </Form.Item>
  )
}
export default InputNumber
